export default __webpack_public_path__ + "822ce4927b41557ec45bc8a950dbae12.svg";